export default () => ({
  tutorialRedirect: {
    shown: false
  }
})
